<template>
  <CRow>
    <CModal
        title="View Event"
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        :hide-footer="true"
        color="primary"
    >

      <CCardBody>
        <CCol md="12" class="align-self-center">
          <CRow>
            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                Title :
              </p>
              <p class="custome-detail">
                {{ self.event.title }}
              </p>
            </CCol>

            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                Description :
              </p>
              <p class="custome-detail">
                {{ self.event.description }}
              </p>
            </CCol>


            <CCol sm="6" md="4" lg="4" v-if="self.event.link">
              <p class="custome-labal">
                Link :
              </p>
              <p class="custome-detail">
                {{ self.event.link }}
              </p>
            </CCol>

            <CCol sm="6" md="4" lg="4" v-if="self.event.location">
              <p class="custome-labal">
                Location :
              </p>
              <p class="custome-detail">
                {{ self.event.location }}
              </p>
            </CCol>


            <CCol sm="6" md="4" lg="4" v-if="self.event.participants">
              <p class="custome-labal">
                Participants :
              </p>
              <p class="custome-detail">
                {{ self.event.participants }}
              </p>
            </CCol>

            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                isFree? :
              </p>
              <p class="custome-detail">
                <CBadge :color="statusBudget(self.event.isFree)">{{ self.event.isFree }}</CBadge>
              </p>
            </CCol>

            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                isOnline? :
              </p>
              <p class="custome-detail">
                <CBadge :color="statusBudget(self.event.isOnline)">{{ self.event.isOnline }}</CBadge>
              </p>
            </CCol>

            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                Start Time :
              </p>
              <p class="custome-detail">
                {{ dateTimeUTCtoLocalFormat(self.event.startTime) }}
              </p>
            </CCol>
            <CCol sm="6" md="4" lg="4">
              <p class="custome-labal">
                End Time :
              </p>
              <p class="custome-detail">
                {{ dateTimeUTCtoLocalFormat(self.event.endTime) }}
              </p>
            </CCol>

          </CRow>
        </CCol>
      </CCardBody>
    </CModal>

    <CCol col="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="12" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">
                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'events',self.userId,self.groupId)"
                  ><i class="fas fa-file-pdf"></i></CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
                <BeforeFilter
                    :filterShow="toggleFilterValue"
                    @getFilterToggle="switchFilter"
                ></BeforeFilter>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <transition name="fade">
            <CRow v-if="toggleFilterValue">

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Registered As</label>
                  <v-select :options="registeredTypes" @option:selected="getUsers"
                            v-model="filter.registeredType"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">Name</label>
                  <v-select :options="list" v-model="filter.list"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">IsFree</label>
                  <v-select :options="isFreeList" v-model="filter.isFree"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group">
                  <label class="form__label">IsOnline</label>
                  <v-select :options="isOnlineList" v-model="filter.isOnline"></v-select>
                </div>
              </CCol>

              <CCol sm="3">
                <div class="form-group" style="margin-top: 30px">
                  <CButton
                      type="submit"
                      size="sm"
                      color="primary"
                      @click="applyFilter()"
                      v-c-tooltip="$lang.common.filter.button.filter"
                  >
                    {{ $lang.common.filter.button.filter }}
                  </CButton>
                  &nbsp;
                  <CButton
                      color="danger"
                      size="sm"
                      @click="resetFilter()"
                      v-c-tooltip="$lang.common.filter.button.cancel"
                  >
                    {{ $lang.common.filter.button.cancel }}
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </transition>
          <v-server-table
              :columns="columns"
              :url="listUrl"
              :options="options"
              ref="myTable"
              @loaded="
                exports(self, 'Excel', module, 'events',self.userId,self.groupId)
              "
          >
            <template #isFree="data">
              <CBadge :color="statusBudget(data.row.isFree)">{{ data.row.isFree }}</CBadge>
            </template>
            <template #isOnline="data">
              <CBadge :color="statusBudget(data.row.isOnline)">{{ data.row.isOnline }}</CBadge>
            </template>
            <template #startTime="data">
              {{ dateTimeUTCtoLocalFormat(data.row.startTime) }}
            </template>
            <template #endTime="data">
              {{ dateTimeUTCtoLocalFormat(data.row.endTime) }}
            </template>
            <template #createdAt="data">
              {{ dateTimeUTCtoLocalFormat(data.row.createdAt) }}
            </template>
            <template #updatedAt="data">
              {{ dateTimeUTCtoLocalFormat(data.row.updatedAt) }}
            </template>
            <template #userName="data">
              <Avatar
                  :image="data.row.avatar"
                  :content="data.row.userName"
                  :isProfileListPage="true"
                  :length="20"
              />
            </template>
            <template #actions="data">
              <CButton
                  color="primary"
                  v-on:click="viewComments(data.row.id,data.row.title)"
              >
                <i class="fas fa-comment"></i>
              </CButton>
              <CButton color="primary" v-on:click="viewEvents(data.row.id)">
                <i class="fas fa-eye"></i>
              </CButton>
              <CButton color="primary" v-on:click="viewReports(data.row.id,data.row.title)">
                <i class="fas fa-eye"></i>
              </CButton>
            </template>

          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {gAC} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import {required} from "vuelidate/lib/validators";
import VueToasted from "vue-toasted";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueJsonToCsv from "vue-json-to-csv";
import BeforeFilter from "../../BeforeFilterOpen";
import Avatar from "/src/components/Avatar";

function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);
export default {
  name: "EventItem",
  mixins: [Mixin],
  components: {
    Avatar,
    BeforeFilter,
    VueJsonToCsv,
  },
  data() {
    return {
      groupId: '',
      userId: '',
      pollName: '',
      list: [],
      isFreeList: [],
      isOnlineList: [],
      registeredTypes: [],
      submitted: false,
      listUrl: '/groups/events/list',
      json_data: [],
      messageColor: "success",
      json_label: {},
      json_title: "",
      toggleFilterValue: false,
      alertMessage: "",
      showAlert: false,
      dismissCountDownS: 0,
      msg: "",
      items: [],
      activePage: 1,
      selectedLetter: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      dismissCountDown: 0,
      statusOptions: [],
      self: this,
      module: gAC,
      event: {
        title: '',
        description: '',
        isFree: '',
        isOnline: '',
        startTime: '',
        endTime: '',
        link: '',
        location: '',
        participants: '',
      },
      filter: {
        isFree: '',
        isOnline: '',
        registeredType: "",
        list: "",
      },
      maxlength: {
        // category: Maxlength.gac.name,
      },
      columns: ["registeredType", "userName", "company", "title", "isFree", "isOnline", "startTime", "endTime", "participants", 'createdAt', 'updatedAt', "actions"],
      data: [],
      options: {
        headings: {
          company: this.$lang.events.table.company,
          registeredType: this.$lang.events.table.registeredType,
          userName: this.$lang.events.table.userName,
          title: this.$lang.events.table.title,
          isFree: this.$lang.events.table.isFree,
          isOnline: this.$lang.events.table.isOnline,
          startTime: this.$lang.events.table.startTime,
          endTime: this.$lang.events.table.endTime,
          participants: this.$lang.events.table.participants,
          createdAt: this.$lang.events.table.createdAt,
          updatedAt: this.$lang.events.table.updatedAt,
          actions: this.$lang.common.general.actions,
        },
        editableColumns: ["name"],
        sortable: [],
        filterable: ["title"],
        // see the options API
      },
    };
  },
  validations: {
    gac: {
      name: {
        required,
      },
    },
  },

  created() {

    let self = this;
    self.dismissCountDown = 0;
    if (this.$route.params.id) {
      self.groupId = this.$route.params.id;
      self.dismissCountDown = 0;
      self.listUrl = self.listUrl + "/" + this.$route.params.id;
    }
    store.commit('showLoader', false); // Loader Start
  },
  mounted() {
    store.commit('showLoader', false); // Loader Start
    let self = this;
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    // self.data = this.loadData();

    self.list = [];
    self.registeredTypes.push(
        {value: "Company", label: 'Company'},
        {value: "Individual", label: 'Individual'},
        {value: "Member", label: 'Member'},
        {value: "Users", label: 'All Users'}
    );
    self.isFreeList.push(
        {value: 1, label: 'Yes'},
        {value: 0, label: 'No'}
    );
    self.isOnlineList.push(
        {value: 1, label: 'Online'},
        {value: 0, label: 'Offline'}
    );

  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    /* get from child component */
    switchFilter(show) {
      this.toggleFilterValue = show;
    },

    getUsers(e) {
      let type = e.value;
      this.getList(type);
    },
    viewComments(eventId, eventName) {
      localStorage.setItem('eventName', eventName);
      this.$router.push({path: `/groups/event/comments/${eventId}`});
    },
    viewReports(eventId, eventName) {
      localStorage.setItem('eventName', eventName);
      this.$router.push({path: `/groups/event/reports/${eventId}`});
    },
    getList(type) {
      let self = this;
      self.userList = "/groups/poll/list/" + this.$route.params.id;
      axios.get(self.userList)
          .then((response) => {
            let responseData = response.data;
            self.list = [];
            responseData.data.map(function (value, key) {
              if (type === 'Users') {
                self.list.push({value: value.userId, label: value.firstName});
              } else if (value.registeredType === type && type === 'Company') {
                self.list.push({value: value.companyId, label: value.company});
              } else if (value.registeredType === type && type !== 'Company') {
                self.list.push({value: value.userId, label: value.name});
              }
            });
            self.list = this.removeDuplicateValues(self.list);
          });
    },

    applyFilter() {
      let self = this;
      let reqObj = {
        registeredType: Object.keys(this.filter.registeredType).length > 0 ? this.checkUndefinedNull(self.filter.registeredType.value) : null,
        id: Object.keys(this.filter.list).length > 0 ? this.checkUndefinedNull(self.filter.list.value) : null,
        isFree: Object.keys(this.filter.isFree).length > 0 ? this.checkUndefinedNull(self.filter.isFree.value) : null,
        isOnline: Object.keys(this.filter.isOnline).length > 0 ? this.checkUndefinedNull(self.filter.isOnline.value) : null,
      };
      store.commit("showLoader", true); // Loader Start
      this.$refs.myTable.customQueries = reqObj;
      this.$refs.myTable.refresh();
    },
    resetFilter() {
      let self = this;
      self.filter.registeredType = [];
      self.filter.list = [];
      store.commit("showLoader", true);
      this.$refs.myTable.customQueries = {};
      this.$refs.myTable.refresh();
    },


    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.gac.name = "";
      self.gac.countryId = "";
      self.largeModal = true;
      self.gac.status = 1;
    },


    viewEvents(eventId) {
      let self = this;
      axios.get('users/groups/events/detail/' + eventId).then((response) => {
        if (response) {
          let responseData = response.data.data;


          self.event.title = responseData.title;
          self.event.description = responseData.description;
          self.event.isFree = responseData.isFree;
          self.event.isOnline = responseData.isOnline;
          self.event.startTime = responseData.startTime;
          self.event.endTime = responseData.endTime;
          self.event.link = responseData.link;
          self.event.location = responseData.location;
          self.event.participants = responseData.participants;


        } else {
          self.data = [];
        }
      });
      self.largeModal = true;
    },

  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
